import { render, staticRenderFns } from "./spam_bounces.vue?vue&type=template&id=182bbb8a"
import script from "./spam_bounces.vue?vue&type=script&lang=js"
export * from "./spam_bounces.vue?vue&type=script&lang=js"
import style0 from "./spam_bounces.vue?vue&type=style&index=0&id=182bbb8a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports